import React from 'react';
import { Navigate } from 'react-router-dom';
import StorageService from '../services/StorageService';

function UserProtectedRoute({ children }) {
  const auth = StorageService.getAuth();
  const isAdmin = auth?.is_admin || false;

  if (!auth) {
    return <Navigate to="/login" />;
  }

  if (isAdmin) {
    return <Navigate to="/access-denied" />;
  }

  return children;
}

export default UserProtectedRoute;
